
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFA329"}},[_c('path',{attrs:{"d":"M8.423 24c-1.722 0-2.957-1.789-3.775-2.972-2.127-3.073-3.342-8.153-1.405-11.516a5.862 5.862 0 014.929-2.983l.079-.001c.866 0 1.654.313 2.348.59.453.181.905.36 1.182.36.24 0 .668-.169 1.121-.348.755-.298 1.694-.669 2.704-.669.134 0 .267.007.397.02a5.601 5.601 0 014.345 2.369.502.502 0 01-.148.714 4.405 4.405 0 00-2.115 3.727 4.31 4.31 0 002.623 3.945.499.499 0 01.281.612 12.489 12.489 0 01-1.573 3.229c-.917 1.342-1.956 2.862-3.738 2.895l-.089.001c-.767 0-1.312-.236-1.793-.443-.53-.23-.976-.423-1.728-.423-.793 0-1.263.2-1.807.432-.499.212-1.012.431-1.745.46L8.423 24zM8.197 7.528a4.86 4.86 0 00-4.084 2.477c-1.295 2.248-1.259 6.674 1.358 10.453C6.396 21.798 7.318 23 8.42 23l.061-.001c.548-.022.938-.188 1.389-.38.563-.24 1.202-.512 2.2-.512.958 0 1.571.265 2.111.499.476.206.849.367 1.41.367l.069-.001c1.267-.023 2.151-1.317 2.932-2.458.541-.794.98-1.655 1.306-2.559a5.345 5.345 0 01-2.811-4.665 5.432 5.432 0 012.13-4.261 4.666 4.666 0 00-3.281-1.55 3.296 3.296 0 00-.317-.016c-.834 0-1.674.332-2.349.598-.568.224-1.058.418-1.488.418-.469 0-.964-.197-1.536-.425-.619-.247-1.32-.526-2-.526h-.049zM11.604 6.3a.503.503 0 01-.492-.465 5.356 5.356 0 011.344-3.928A5.625 5.625 0 0116.17.002L16.218 0a.5.5 0 01.498.462 5.543 5.543 0 01-1.312 4.031A4.802 4.802 0 0111.665 6.3h-.061zm4.124-5.219a4.66 4.66 0 00-2.523 1.489 4.385 4.385 0 00-1.102 2.705 3.771 3.771 0 002.525-1.411 4.587 4.587 0 001.1-2.783z"}})])])
          )
        }
      }
    